import React, { useEffect } from 'react';
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import './globals.css';

const AboutIWPFI = () => {
  useEffect(() => {
    document.title = "IWPFI2026_About IWPFI";
  }, []);
  return (
    <div id="everything">
      <NavigationBar />

      <main className="page-about">
        {/* Intro / overview */}
        <section className="about-section">
          <h1 className="about-title">About IWPFI</h1>

          <p>
            The IWPFI mission is to: enable broad international discussion and decision making in the field of 
            pulmonary functional imaging, accelerating new developments into clinical practice and aimed at 
            improving patient outcomes.
          </p>

          <p>
            Since 2002, the International Workshop for Pulmonary Functional Imaging (IWPFI) has brought together 
            150-300 international experts from across many disciplines who study lung diseases and work on 
            developing new imaging tools and applications to better understand the structure and function of the
            lungs. This scientific meeting occurs every 2 years and alternates between Europe, Australasia and 
            North America. The meeting is also the venue for the awarding of the John West Gold Medal, recognizing 
            excellence in pulmonary functional imaging research and development as well as the Gefter-Hatabu Young 
            Investigator award.  
          </p>

          <p>
            The inaugural meeting of the IWPFI was planned for September 2001 but was paused due to the events of 9/11 
            and moved to 2002 in Philadelphia. The brainchild and passion project of Drs Warren Gefter (U Penn) and 
            Hiroto Hatabu (Harvard), the biennial meeting is held in a workshop format to address emerging clinical needs 
            for improved diagnosis and assessment of lung diseases through the development of novel imaging-based approaches. 
          </p>

          <p>
            Subsequent meetings have been held on Awaji Island (2004), Heidelberg (2007), Boston (2009), Awaji (2011), 
            Madison (2013), Edinburgh (2015), Seoul (2017), New Orleans (2019), Hannover (2022) and Otsu City (2024) 
          </p>

        </section>
        <div className="footer-logo">
          <img src="/images/iwpfi_horizontal_logo.jpg" alt="Logo" />
        </div>
    </main>
    
    <Footer />
    </div>
    );
};

export default AboutIWPFI;